// extracted by mini-css-extract-plugin
export var card = "_redotech-redo-customer-portal-app-lib-login-login-card";
export var cardContent = "_redotech-redo-customer-portal-app-lib-login-login-card-content";
export var cardScrollable = "_redotech-redo-customer-portal-app-lib-login-login-card-scrollable";
export var fadeIn = "_redotech-redo-customer-portal-app-lib-login-login-fadeIn";
export var slideIn = "_redotech-redo-customer-portal-app-lib-login-login-slideIn";